import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  FETCH_GROUP,
  RESET_GROUP_MEMBERS_PAGINATION_STATE,
  SET_FILTER_GROUP_MEMBER,
  SET_GROUP_MEMBERS_SORTING_STATE
} from './actionTypes'

export const fetchGroup = (groupId: string): AppThunk => {
  return dispatch => {
    return dispatch(request(`/organizations/:organizationId/groups/${groupId}`, FETCH_GROUP, {}))
  }
}

export const setSortingColumn = (sortBy?: string, sortOrder?: string): AppThunk => {
  return dispatch => {
    dispatch(
      createAction(SET_GROUP_MEMBERS_SORTING_STATE, {
        sortingColumn: sortBy && sortOrder ? { [sortBy]: { direction: sortOrder.toLowerCase() } } : {}
      })
    )
  }
}

export const setFilter = (filter: unknown): AppThunk => {
  return dispatch => dispatch(createAction(SET_FILTER_GROUP_MEMBER, { filter }))
}

export const resetPaginationState = (): AppThunk => {
  return dispatch => dispatch(createAction(RESET_GROUP_MEMBERS_PAGINATION_STATE))
}
